// src/pages/ConversationListPage.jsx

import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const API_BASE = "http://localhost:4000";
//const API_BASE = "https://myjourneytrails.com";

export default function ConversationListPage() {
  const navigate = useNavigate();

  const [personal, setPersonal] = useState([]);
  const [shared, setShared] = useState([]);

  useEffect(() => {
    async function load() {
      const res = await fetch(`${API_BASE}/api/conversations`, {
        credentials: "include"
      });
      const data = await res.json();

      setPersonal(data.personal || []);
      setShared(data.shared || []);
    }
    load();
  }, []);

  async function startPersonalConversation() {
    const res = await fetch(`${API_BASE}/api/personal/create`, {
      method: "POST",
      credentials: "include"
    });

    const data = await res.json();
    console.log("Create convo response:", data);
    if (!res.ok) {
      alert(data.error || "Failed to start conversation");
      return;
    }

    navigate(`/personal/${data.conversationId}`);
  }

  return (
    <div className="page-wrap">
      <h1>Your Conversations</h1>

      <button onClick={startPersonalConversation}>
        Start New Personal Conversation
      </button>

      <h2>Personal</h2>
      {personal.length === 0 && <p>No personal conversations yet.</p>}
      {personal.map((c) => (
        <Link key={c.conversation_id} to={`/personal/${c.conversation_id}`}>
          <div className="conversation-item">
            Personal Conversation — {new Date(c.created_at).toLocaleString()}
          </div>
        </Link>
      ))}

      <h2>Companion</h2>
      {shared.length === 0 && <p>No companion conversations yet.</p>}
      {shared.map((c) => (
        <Link key={c.token} to={`/shared/${c.token}`}>
          <div className="conversation-item">
            With {c.companion_name || "Companion"} —{" "}
            {new Date(c.created_at).toLocaleString()}
          </div>
        </Link>
      ))}
    </div>
  );
}
